module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [(_vm.show) ? _c('div', {
    ref: "modal",
    class: _vm.classes,
    attrs: {
      "role": "dialog",
      "aria-labelledby": "modal"
    },
    on: {
      "mousedown": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        $event.stopPropagation();
        return _vm.close.apply(null, arguments)
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.close.apply(null, arguments)
      }
    }
  }, [_c('div', {
    class: ['modal-dialog', _vm.dialog],
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [(_vm.header) ? _c('div', {
    staticClass: "modal-header",
    class: _vm.headerClass,
    style: (_vm.headerStyle)
  }, [_c('div', {
    staticClass: "modal-title bold"
  }, [_vm._t("title", function() {
    return [_vm._v(_vm._s(_vm.title))]
  })], 2), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "id": "close",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.close.apply(null, arguments)
      }
    }
  }, [_c('span', [_vm._v("×")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(!_vm.header) ? _c('button', {
    staticClass: "close noHeader",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.close.apply(null, arguments)
      }
    }
  }, [_c('span', [_vm._v("×")])]) : _vm._e(), _vm._v(" "), _vm._t("body")], 2), _vm._v(" "), (_vm.footer) ? _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", function() {
    return [_c('button', {
      class: _vm.cancelClass,
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.close.apply(null, arguments)
        }
      }
    }, [_vm._v(_vm._s(_vm.cancelText))]), _vm._v(" "), _c('button', {
      class: _vm.okClass,
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.ok.apply(null, arguments)
        }
      }
    }, [_vm._v(_vm._s(_vm.okText))])]
  })], 2) : _vm._e()])])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-79b296f4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79b296f4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/Modal.vue
// module id = 1236
// module chunks = 0